import { EVENT_ALERT_STATUS, LANGUAGE_ALERT_STATUS, MEMBERS_ALERT_STATUS, NOTICE_ALERT_STATUS } from "../constants/adminConstants";


export const alertReducer = (state ={eventAlertStatus: false, languagesAlertStatus: false, membersAlertStatus: false, noticeAlertStatus: false}, action) => {

    switch(action.type) {
        case EVENT_ALERT_STATUS:
            return {
                ...state,
                eventAlertStatus: action.payload
            };
        case LANGUAGE_ALERT_STATUS:
            return {
                ...state,
                languagesAlertStatus: action.payload
            };
        case MEMBERS_ALERT_STATUS:
            return {
                ...state,
                membersAlertStatus: action.payload
            };
        case NOTICE_ALERT_STATUS:
            return {
                ...state,
                noticeAlertStatus: action.payload
            };
        
        default: 
            return state
    }
}